import { t, type TranslationKey } from "./i18n.ts";
import type { ModuleId } from "../auth/config.ts";

/**
 * The unit each module counts in — "conversations" for Teams, "files" for
 * OneDrive, and so on. One source of truth so the Browse row and the viewer
 * header always agree, and so the count shown matches exactly what the
 * module's index lists (never the raw IndexedDB item total, which mixes in
 * inline images and folders).
 */
export const MODULE_UNIT: Record<ModuleId, TranslationKey> = {
    teams: "viewer.unit.teams",
    mail: "viewer.unit.mail",
    onedrive: "viewer.unit.onedrive",
    calendar: "viewer.unit.calendar",
    contacts: "viewer.unit.contacts",
    tasks: "viewer.unit.tasks",
    onenote: "viewer.unit.onenote"
};

/**
 * "8 conversations" / "1 conversation". Every unit here (in both languages)
 * is a plural that becomes singular by dropping a trailing "s", so a count of
 * one is handled with that one rule rather than a second key per unit.
 */
export function formatModuleCount(count: number, moduleId: ModuleId): string {
    const unit = t(MODULE_UNIT[moduleId]);
    const shown = count === 1 ? unit.replace(/s$/, "") : unit;
    return t("viewer.count", { count, unit: shown });
}
